import { useEffect, useMemo, useState } from 'react';

// for paginating data
export default function usePagination<T>(data?: T[], pageSize: number = 0, startPage: number = 1): [
  number, // page count
  T[] | undefined, // paged data
  number, // current page number
  (page: number) => void // turn page, for caller to load paged data
] {
  const [pageNumber, setPageNumber] = useState(1);

  const pageCount = useMemo(() => {
    return data && pageSize > 0 ? Math.ceil(data.length / pageSize) : 1;
  }, [data, pageSize]);

  const pagedData = useMemo(() => {
    if (!data || pageCount === 1) return data;

    const start = (pageNumber - 1) * pageSize;
    return data.slice(start, start + pageSize);
  }, [data, pageCount, pageNumber, pageSize]);

  useEffect(() => {
    setPageNumber(startPage);
  }, [data, pageSize]);
  
  const handlePageChange = (page: number) => {
    if (pageSize > 0) {
      const n = Math.min(Math.max(page, 1), pageCount);
      setPageNumber(n);
    }
  };

  return [pageCount, pagedData, pageNumber, handlePageChange];
}
